var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{ref:"timeValidator",attrs:{"name":"Time","rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-text-field',{attrs:{"type":"time","value":_vm.value,"error-messages":errors,"hide-details":"auto","filled":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }